import { ShapePlusOutlineIcon } from './ShapePlusOutlineIcon';

/**
 * author: Jeff Anders
 * id 3800615A-AAC6-43C8-9ACD-F8C7A0910C07
 * name shape-plus-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shape-plus-outline.svg
 * tags
 * - Shape 
 */
export const ShapeAddOutlineIcon = ShapePlusOutlineIcon;
export default ShapeAddOutlineIcon